module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ach"
  }, [_c('em', [_vm._v("Other titles by Laurie Graham")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("Fiction")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_vm._v("The Man for the Job")]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_vm._v("The Ten O'clock Horses")]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_vm._v("Perfect Meringues")]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_vm._v("The Dress Circle")]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_vm._v("Dog Days, Glenn Miller Nights")]), _vm._v(" "), _c('p', {
    staticClass: "acl1"
  }, [_c('em', [_vm._v("Non-fiction")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_vm._v("The Parent's Survival Guide")]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_vm._v("The Marriage Survival Guide")]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_vm._v("Teenagers")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1cdf5da6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FutureHomemake_adca-1.vue
// module id = 69
// module chunks = 0